<template>
  <div class="user-charge">
    <el-dialog title="充值" :visible.sync="showRecharge" width="496px" :close-on-click-modal="true" :before-close="close">
      <div class="same_text">购买数量</div>
      <ul class="number_list">
        <li v-for="item in moneyList" :key="item.id" @click="changeNumber(item)" :class="[changeNumberId == item.id ? 'active_li' : '']">
          <div class="top_d">
            <span>{{ item.m }}</span>
            <div class="recharge-unit">
              <img class="recharge-icon" src="./img/mine_top_jinkela.png" alt />
              <span>克拉</span>
            </div>
          </div>
          <div class="bottom_d">
            <span class="bottom-unit">￥</span>
            <span>{{ item.t }}</span>
          </div>
        </li>
      </ul>
      <div class="item_money">
        <span class="other_money">其他金额</span>
        <el-input
          maxlength="5"
          type="text"
          v-model="inputMoney"
          onkeydown="value=value.replace(/^(0+)|[^\d]+/g,'')"
          onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
          placeholder="输入金额1-99999的整数"
          style="flex: 1"
          :class="[inputMoney ? '' : 'gray-bg']"
        ></el-input>
      </div>
      <div class="same_text">支付方式</div>
      <ul class="pay_method">
        <li v-for="item in payList" :key="item.id" @click="changePay(item)" :class="[payMethodId == item.id ? 'active_li' : '']">
          <img :src="item.g" alt />
          <span>{{ item.m }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer-recharge">
        <div class="footer-btn cancel" @click="closeRecharge">取消</div>
        <div class="footer-btn confirm" @click="onSubmit">确认</div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: {},
  data() {
    return {
      showRecharge: false,
      moneyList: [
        { id: "1", m: 10, t: 10 },
        { id: "2", m: 20, t: 20 },
        { id: "3", m: 30, t: 30 },
        { id: "4", m: 40, t: 40 },
        { id: "5", m: 50, t: 50 },
        { id: "6", m: 60, t: 60 },
        { id: "7", m: 70, t: 70 },
        { id: "8", m: 80, t: 80 },
      ],
      payList: [
        { id: "1", m: "微信", g: require("./img/mine_pay_weixin.png") },
        { id: "2", m: "支付宝", g: require("./img/mine_pay_zhifubao.png") },
        { id: "3", m: "银行卡", g: require("./img/mine_pay_yinhangka.png") },
      ],
      changeNumberId: "0",
      payMethodId: "1",
      inputMoney: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    open() {
      this.showRecharge = true;
    },
    close() {
      this.showRecharge = false;
    },
    closeRecharge() {
      this.showRecharge = false;
    },
    changeNumber(item) {
      this.changeNumberId = item.id;
      this.inputMoney = item.m;
    },
    changePay(item) {
      this.payMethodId = item.id;
    },

    onSubmit() {
      if (!this.userInfo.id) {
        this.showRecharge = false;
        this.toggleLogin();
        return;
      }
      // 暂不调用充值接口
      // this.$emit("toCancelRecharge");
    },
  },
};
</script>

<style lang="stylus" scoped>
.user-charge {
    /deep/ .el-dialog {
        border-radius: 8px;
    }
    /deep/ .el-dialog__header {
        padding: 24px;
    }

    /deep/ .el-dialog__body {
        padding: 0 24px;
    }

    /deep/ .el-dialog__footer {
        padding: 0 24px 16px 24px;
    }

    /deep/ .el-input--small .el-input__inner {
        height: 40px;
        line-height: 40px;
        border: 1px solid #f0f0f0;
    }

    /deep/ .gray-bg .el-input__inner {
        background: #f7f7f7;
    }

    .same_text {
        margin-bottom: 16px;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
    }

    .item_money {
        width: 100%;
        height: 40px;
        display: flex;
        line-height: 40px;
        margin-bottom: 24px;
    }

    .other_money {
        font-size: 14px;
        color: #666666;
        margin-right: 24px;
    }

    .number_list {
        display: flex;
        flex-wrap: wrap;

        li {
            width: 100px;
            height: 88px;
            background: #f7f7f7;
            border-radius: 8px;
            margin-right: 16px;
            box-sizing: border-box;
            margin-bottom: 16px;
            cursor: pointer;

            .top_d {
                height: 56px;
                font-size: 14px;
                line-height: 20px;
                color: #666666;
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: column;
                padding: 8px 0;
                border: 1px solid #f7f7f7;
                border-radius: 8px 8px 0 0;
            }
            .recharge-icon {
                width: 16px;
                height: 16px;
                margin-right: 4px;
            }

            .recharge-unit {
                font-size: 10px;
                line-height: 16px;
                display: flex;
            }
            .bottom_d {
                // width: 100px;
                height: 32px;
                background: #f0f0f0;
                font-size: 20px;
                color: #333333;
                display: flex;
                align-items: flex-end;
                justify-content: center;
                border-radius: 0 0 8px 8px;
                padding: 4px 0;
                line-height: 24px;
                font-weight: 500;
            }

            .bottom-unit {
                font-size: 10px;
                line-height: 20px;
                font-weight: 400;
            }

            &:nth-child(4n) {
                margin-right: 0;
            }
        }
        .active_li {
            .top_d {
                border: 1px solid #26d99d;
                background: rgba(38, 217, 157, 0.1);
                color: #26d99d;
            }

            .bottom_d {
                background: #26d99d;
                color: #ffffff;
            }
        }
    }

    .pay_method {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 48px;
        li {
            width: 106px;
            height: 48px;
            background: #f7f7f7;
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #666666;
            overflow: hidden;
            margin-right: 16px;
            cursor: pointer;

            img {
                width: 24px;
                height: 24px;
                margin-right: 8px;
            }
        }
        .active_li {
          background: linear-gradient(101.98deg, #FF3838 10.8%, #D02D54 95.33%);
          border: 1px solid #FF3838;
        }
    }

    .dialog-footer-recharge {
        display: flex;
        justify-content: center;
        height: 40px;
        text-align: center;
        line-height: 40px;
    }

    .footer-btn {
        font-size: 18px;
        flex-grow: 1;
        margin-right: 24px;
        border-radius: 20px;
        cursor: pointer;

        &:last-child {
            margin-right: 0;
        }
    }

    .confirm {
        background: #26d99d;
        color: #ffffff;
    }

    .cancel {
        background: #f7f7f7;
        color: #666666;
    }
}
</style>
